




























































































































import Vue from 'vue'
import ContactFormDemo from '@/components/ContactFormDemo.vue'
import Form, {
    FormField,
    FormMessage,
    FormMessageAttribute,
    FormStyles
} from '@/types/Form.interface'
import FormSubmission from '@/types/FormSubmission.interface'
import FormLinks from '@/components/FormLinks.vue'
import FormFields from '@/components/FormFields.vue'
import FormMessages from '@/components/FormMessages.vue'
import FormStyleEditor from '@/components/FormStyleEditor.vue'
import FormSubmissions from '@/components/FormSubmissions.vue'
import { mapGetters } from 'vuex'
import ScrollPosition from '@/types/components/ScrollPosition.interface'
export default Vue.extend({
    components: {
        ContactFormDemo,
        FormFields,
        FormLinks,
        FormMessages,
        FormStyleEditor,
        FormSubmissions
    },
    props: ['id'],
    data: () => ({
        //  A loading spinner for when we are fetching form
        loading: false,
        //  Determines if we are ready to dispaly data
        mounted: false,
        //  Our page template toolbar
        toolbar: {
            title: 'Forms',
            help: {
                title: 'Forms',
                body: 'Grow your text message subscriber list by sharing forms on your website, social pages, or with a QR code. Customize forms to collect the right information so you can organize your contacts into groups for Broadcast messaging.',
                button: {
                    text: ' Learn More',
                    link: `${process.env.VUE_APP_URL_LEARN}/en/articles/5076369-contact-forms-overview`
                }
            },
            left: [
                {
                    title: 'Back',
                    icon: 'mdi-chevron-left',
                    back: '/forms',
                    tooltip: 'Back',
                    permission: 0,
                    feature: null
                }
            ],
            right: []
        },
        //  Displays form submissions or form editor
        viewFormSubmissions: false,
        //  Determines if the contact form demo shows the success page or not
        successView: false,
        titleFocused: false
    }),
    async mounted() {
        //  Check if a form is set in the url params
        const id = this.id

        //  Start loading
        this.loading = true

        //  If there is an id set, load it
        if (id) await this.$store.dispatch('formsViewSelectedFormGet', id)

        //  Stop loading
        this.loading = false

        //  We use this mounted variable to track that we have finished setup
        this.mounted = true
    },
    beforeDestroy() {
        //  Due to the unique setup of the forms component, we need to do some clean up before we go back to FormsIndex.vue
        //  otherwise issues like showing submissions for the wrong form can occur
        this.unsetForm()
    },
    computed: {
        ...mapGetters({
            params: 'formsViewSubmissionsParams',
            lastPage: 'formsViewSubmissionsLastPage',
            scrollPositionLeft: 'scrollPositionLeft',
            paginating: 'formsViewSubmissionsPaginating'
        }),
        brandingEnabled(): boolean {
            return this.$store.getters.getEnabled('branding')
        },
        footerDisplay(): boolean {
            return this.selectedForm.styles?.footer.display
        },
        formDefaultInputs(): FormField[] {
            return this.$store.getters.formDefaultInputs
        },
        formMessages(): FormMessage[] {
            return [
                {
                    title: 'Anonymous lead first message',
                    helpText:
                        'Anonymous contacts recieve this message when they first contact your number',
                    attribute: FormMessageAttribute.send_message,
                    text: this.selectedForm.send_message,
                    media: this.selectedForm.send_media,
                    hidden: !this.isContactForm
                },
                {
                    title: 'Form submission thank you message',
                    helpText:
                        'All contacts recieve this message when they submit the form',
                    attribute: FormMessageAttribute.response_message,
                    text: this.selectedForm.response_message,
                    media: this.selectedForm.response_media
                }
            ]
        },
        //  These are our panels that get displayed for editing forms
        formPanels(): object[] {
            return [
                {
                    title: 'Step 1: Form Fields',
                    description: 'Edit the fields that appear on the form',
                    type: 'fields'
                },
                {
                    title: 'Step 2: Form Styling',
                    description: 'Edit CSS styles and images',
                    type: 'styles'
                },
                {
                    title: 'Step 3: Form Messages',
                    description: this.messageHeaderDesc,
                    type: 'messages'
                },
                {
                    title: 'Step 4: Share Form',
                    description: 'Share your form and collect info about your contacts.',
                    type: 'links'
                }
            ]
        },
        //  Our description for the form group payload
        groupDesc(): string {
            //  If no selectedForm, return ''
            if (!this.selectedForm) return ''

            //  Else, grab the selectedForm name
            const name = this.selectedForm.name

            //  Create a substring from this name
            const sub = `${name.substring(0, 150)}...`

            //  Our description will always start with the same substr
            const start = 'A form group containing '

            //  If this is over 153 then it is our start + sub, Else just append submissions
            const desc = name.length >= 153 ? start + sub : `${start}${name} submissions`

            //  Return our description
            return desc
        },
        //  Our name for the form group payload
        groupName(): string {
            //  If no selectedForm, return ''
            if (!this.selectedForm) return ''

            //  Else, grab the selectedForm name
            const name = this.selectedForm.name

            //  Create a substring from this name
            const sub = `${name.substring(0, 30)}...`

            //  If this is over 33 then it is our sub, Else just append Submissions
            const fName = name.length >= 33 ? sub : `${name} submissions`

            //  Return our name
            return fName
        },
        hasPhoneNumberField(): boolean {
            //  If no selectedForm, return false
            if (!this.selectedForm) return false

            //  Grab our fields from selectedForm
            const fields = this.selectedForm.fields

            //  Check if we have a phone path in here
            const phone = fields.find((input: FormField) => {
                return input.path === 'phone_default.free_form_number'
            })

            //  The condition is based on whether or not phone exists
            return phone != null
        },
        isContactForm(): boolean {
            //  If selectedForm is not set, return false
            if (!this.selectedForm) return false

            //  Convert our type on our form to lower case
            const type = this.selectedForm.type.toLowerCase()

            //  Return true if the type is a contact form or C
            return type === 'contactform' || type === 'c'
        },
        links(): object[] {
            return [
                {
                    header: {
                        text: 'Link to Form',
                        icon: 'mdi-help-circle',
                        callback: () => {
                            this.$store.dispatch('dialogOpen', {
                                type: 'MESSAGE',
                                title: 'Help',
                                text: 'This is a permanent link to your form.',
                                icon: 'mdi-help-circle',
                                color: 'primary'
                            })
                        }
                    },
                    value: `${this.selectedForm.long_link}`,
                    tooltip: true
                },
                {
                    header: {
                        text: 'Embed Form on Website',
                        icon: 'mdi-help-circle',
                        callback: () => {
                            this.$store.dispatch('dialogOpen', {
                                type: 'MESSAGE',
                                title: 'Help',
                                text: 'Embed the form on your website using this iframe component.',
                                icon: 'mdi-help-circle',
                                color: 'primary'
                            })
                        }
                    },
                    value: `<iframe src="${this.selectedForm.long_link}" height="500" width="360" style="border-radius:25px;"></iframe>`,
                    tooltip: true
                }
            ]
        },
        messageHeaderDesc(): string {
            return this.isContactForm
                ? 'Edit the form anonymous lead and submission message'
                : 'Edit the form submission message'
        },
        selectedForm: {
            get(): Form {
                return this.$store.getters.formsViewSelectedForm
            },
            set(val: Form): void {
                this.$store.commit('formsViewSelectedFormSet', val)
            }
        },
        selectedFormSubmissions: {
            get(): FormSubmission[] {
                return this.$store.getters.formsViewSubmissions
            },
            set(val: FormSubmission[]): void {
                this.$store.commit('formsViewSubmissionsSet', val)
            }
        }
    },
    methods: {
        async createFormGroup(persons: number[] = []): Promise<void> {
            //  Now that we have our group name and desc, make our payload
            const payload = {
                name: this.groupName,
                desc: this.groupDesc,
                persons_ids: persons
            }

            // Send a groups post request
            const resp = await this.$store.dispatch('groupsPost', payload)

            //  If the response was not successful, do nothing
            if (!resp) return

            // Update the group id
            this.selectedForm.group_id = resp.id
            this.$store.dispatch('formsPut', this.selectedForm)

            //  Pop a dialog
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Success!',
                text: 'Do you want to navigate to the group?',
                icon: 'mdi-check',
                color: 'primary',
                callback: (result: boolean): void => {
                    //  If result was false then do nothing
                    if (!result) return

                    //  Else, navigate to the group
                    this.$router.push(`/groups/${resp.id}`)
                }
            })
        },
        onContactFormToggled(bool: boolean): void {
            //  Update the contact form
            this.updateForm()
        },
        onStyleEditorChanged(): void {
            // Set the form name to the form title input in the style editor
            this.selectedForm.name = this.selectedForm.styles.form.title.value
        },
        onTitleBlur(): void {
            // Set the title focus flag to false
            this.titleFocused = false

            // Update the form
            this.updateForm()
        },
        //  Paginate the next page of the current filtered list
        async paginateCurrentList(): Promise<void> {
            //  Get current pagination params
            const params = this.params

            //  Determine the next page
            const nextPage = params.page + 1

            //  Determine is the page exists, or we're already at the end of pagination
            const shouldPaginate = nextPage <= this.lastPage 

            //  If we should NOT paginate, do nothing
            if (!shouldPaginate) return

            //  Else, update pagination params
            params.page = nextPage

            //  Update our parameters to have the new page 
            this.$store.commit('formsViewSubmissionsParamsSet', params)
    
            //  Paginate the next page, we pass the form_id so the api knows what form to get the submissions from
            await this.$store.dispatch('formsViewSelectedFormSubmissionsGet', this.selectedForm.id)
        },
        popPhoneNumberFieldError(): void {
            return this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Error',
                text: "A 'Default Phone' contact field is required",
                icon: 'mdi-alert-circle-outline',
                color: 'primary'
            })
        },
        removeBranding(): void {
            //  If they do not have access to branding, then pop a dialog
            if (!this.brandingEnabled) {
                return this.$store.dispatch('dialogOpen', {
                    type: 'FEATURE',
                    paywall_type: 'access',
                    metadata: 'branding_enabled'
                })
            }

            //  Else remove the powered-by branding branding
            this.selectedForm.styles.footer.display = false

            //  Update and refresh form
            this.updateForm()
        },
        submitStyles(formStyles: FormStyles): void {
            //  Set the styles of the form
            this.selectedForm.styles = formStyles

            //  Update and refresh form
            this.updateForm()
        },
        unsetForm(): void {
            //  Unset our selected form
            this.selectedForm = null

            //  Unset our submissions
            this.selectedFormSubmissions = []

            //  The vuex store for pagination for form submissions is shared across all forms so this reset is needed
            //  We reset our parameters to the default, the form_id gets set when the component gets mounted
            //  so we don't need to worry about that
            this.$store.commit('formsViewSubmissionsParamsSet', {page: 1})
        },
        async updateForm(): Promise<void> {
            // If the form does not have a default phone field, pop an error and return
            if (!this.hasPhoneNumberField) {
                return this.popPhoneNumberFieldError()
            }

            //  Start loading
            this.loading = true

            // Send the request I CHANGED SOME SHIT HERE SO MAKE SURE TEMP GETS UPDATED?
            await this.$store.dispatch('formsPut', this.selectedForm)

            //  Stop loading
            this.loading = false
        },
        updateFormMessage(obj: FormMessage): void {
            //  Grab the attribute from our form message
            const attr = obj.attribute

            //  Based on this attribute, we want either response or send text
            if (attr === 'send_message') {
                this.selectedForm.send_message = obj.text
                this.selectedForm.send_message_media_id = obj.media?.id
            } else {
                this.selectedForm.response_message = obj.text
                this.selectedForm.response_message_media_id = obj.media?.id
            }

            //  Update and refresh form
            this.updateForm()
        }
    },
    watch: {
        id(val: number): void {
            //  Set our form to this new id
            this.$store.dispatch('formsViewSelectedFormGet', val)
        },
        scrollPositionLeft(position: ScrollPosition): void {
            //  If we are NOT paginating AND scroll is at bottom, paginate next page
            if (!this.paginating && position.bottom) this.paginateCurrentList()
        },
        selectedForm(form: Form): void {
            //  If form is set to null, make sure we set our submissions to null too
            if (!form) return this.unsetForm()

            //  Else, we have to get our form submissions for this form
            this.$store.dispatch('formsViewSelectedFormSubmissionsGet', form.id)
        }
    }
})
